import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { coimbatore } from "../content/site";
import { Button, Container, Reveal, SectionHeading } from "./ui";

function scrollTo(e, href) {
  e.preventDefault();
  document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
}

// Stylized, non-literal positions — illustrative map layout, not geographically accurate.
const PIN_POSITIONS = [
  { top: "22%", left: "48%" },
  { top: "38%", left: "24%" },
  { top: "34%", left: "70%" },
  { top: "58%", left: "56%" },
  { top: "72%", left: "30%" },
  { top: "64%", left: "78%" },
];

export default function CoimbatoreLaunch() {
  return (
    <section className="bg-[var(--color-bg-soft)] py-20 sm:py-28">
      <Container>
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <Reveal>
            <SectionHeading
              align="left"
              eyebrow={coimbatore.launchLine}
              title={coimbatore.headline}
              body={coimbatore.body}
            />
            <Button
              href="#waitlist"
              onClick={(e) => scrollTo(e, "#waitlist")}
              size="lg"
              className="mt-8"
            >
              {coimbatore.cta}
            </Button>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="relative aspect-square w-full max-w-md rounded-[28px] border border-navy/8 bg-white p-4 shadow-navy mx-auto">
              <div className="relative h-full w-full overflow-hidden rounded-2xl bg-navy">
                <svg className="absolute inset-0 h-full w-full opacity-[0.15]" aria-hidden="true">
                  <pattern id="cbe-grid" width="24" height="24" patternUnits="userSpaceOnUse">
                    <path d="M24 0H0V24" fill="none" stroke="#FF6A00" strokeWidth="0.75" />
                  </pattern>
                  <rect width="100%" height="100%" fill="url(#cbe-grid)" />
                </svg>

                {coimbatore.areas.map((area, idx) => (
                  <motion.div
                    key={area}
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.4, delay: idx * 0.08, ease: [0.16, 1, 0.3, 1] }}
                    className="absolute -translate-x-1/2 -translate-y-full"
                    style={PIN_POSITIONS[idx]}
                  >
                    <div className="flex flex-col items-center">
                      <div className="mb-1 rounded-lg bg-white px-2.5 py-1 text-center shadow-lg">
                        <p className="text-[11px] leading-tight font-extrabold whitespace-nowrap text-navy">
                          {area}
                        </p>
                        <p className="text-[9px] leading-tight font-bold text-primary uppercase">
                          {coimbatore.areaTag}
                        </p>
                      </div>
                      <MapPin size={22} className="fill-primary text-primary drop-shadow" />
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
